export function formatNumber(value: number, decimalPlaces?: number): string {
  // Разбиваем число на целую и дробную части
  let [integerPart, decimalPart] = value.toString().split('.')

  // Добавляем разделители тысяч
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // Если передано decimalPlaces, обрезаем дробную часть без округления
  if (decimalPlaces !== undefined && decimalPart) {
    decimalPart = decimalPart.substring(0, decimalPlaces)
  }

  // Склеиваем обратно, если есть дробная часть
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart
}
